import * as yup from "yup";
import { isRequired, mustBeNumber, mustBePositive, mustBeInRange } from "./messages";

export const ProductValidation = yup.object().shape({
	name: yup
		.string()
		.required(isRequired("Product Name"))
		.min(1, "Product name cannot be empty")
		.max(200, "Product name must be no more than 200 characters"),
	brand: yup.string().nullable(),
	serving_size: yup
		.number()
		.typeError(mustBeNumber("Serving size"))
		.required(isRequired("Serving Size"))
		.positive(mustBePositive("Serving size"))
		.min(0.01, "Serving size must be greater than 0"),
	cost_margin: yup
		.number()
		.typeError(mustBeNumber("Cost margin", "percentage"))
		.required(isRequired("Cost Margin"))
		.min(0, "Cost margin cannot be negative")
		.max(100, "Cost margin cannot exceed 100%"),
	cost: yup
		.number()
		.typeError(mustBeNumber("Cost", "currency"))
		.required(isRequired("Cost"))
		.min(0, "Cost cannot be negative"),
	markup: yup
		.number()
		.typeError(mustBeNumber("Markup", "percentage"))
		.required(isRequired("Markup"))
		.min(0, "Markup cannot be negative")
		.max(1000, "Markup seems unusually high. Please verify."),
	created_date: yup
		.string()
		.required(isRequired("Created Date"))
		.matches(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
	fulfillment_date: yup
		.string()
		.required(isRequired("Fulfillment Date"))
		.matches(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
	flavor: yup.string().max(100, "Flavor name must be no more than 100 characters"),
	manufacturer: yup.string().nullable(),
	ingredients:
		yup.string() ||
		yup.array().of(
			yup.object().shape({
				ingredient: yup.object().shape({
					jf_display_name: yup
						.string()
						.required(isRequired("Ingredient Name"))
						.min(1, "Ingredient name cannot be empty"),
					id: yup.string().required("Ingredient ID is required")
				}),
				weight: yup
					.number()
					.typeError(mustBeNumber("Weight"))
					.required(isRequired("Weight"))
					.positive(mustBePositive("Weight"))
					.min(0.001, "Weight must be greater than 0")
					.transform(Number),
				unit: yup.string().required("Unit is required")
			})
		)
});
